import type { ShipmentColumn } from '../../types/column-types'
import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import { onAnyStandardCell } from '../../helpers/helpers'
import { purple, green, magenta, red } from '@ant-design/colors'
import {
    validateCostOfAllCopies,
    validateProfitOfAllCopies,
    validateProfitPerHour,
} from '../../../../helpers/table-cell-validators'
import { renderShipmentCalculated } from '../../helpers/render-shipment-calculated'
import { CaretDownFilled, CaretUpFilled} from '@ant-design/icons'
import { isShipmentCalculatedOnActual } from '../../../../helpers/entities/shipment/get-shipment-display-calculated'
import { getShipmentDisplayCopiesSum } from '../../../../helpers/entities/shipment/get-shipment-display-copies'

export const moneyGroupColumn: ShipmentColumn = {
    key: 'moneyGroup',
    dataIndex: ['calculated', 'money'],
    title: 'Деньги',
    // @ts-ignore
    children: [
        {
            key: 'costOfOneLabel',
            dataIndex: ['calculated', 'costOfOneLabel'],
            title: 'Себестоимость 1 шт',
            width: 80,
            render: renderShipmentCalculated((calculated, shipment) => {
                if (shipment.shipmentType === 'colorProof') return null

                const copies = getShipmentDisplayCopiesSum(shipment.shipment_positions)

                return (
                    Math.round(((calculated?.costOfAllCopies || 0) / (copies || 1)) * 100) / 100
                )
            }),
        },
        {
            key: 'costOfAllCopies',
            dataIndex: ['calculated', 'costOfAllCopies'],
            title: 'Себестоимость тиража',
            width: 80,
            onHeaderCell: () => ({
                style: {
                    backgroundColor: purple[1],
                },
            }),
            onCell: (record: any) => {
                return {
                    ...onAnyStandardCell(record),
                    style: {
                        backgroundColor: purple[1],
                        fontWeight: '600',
                    },
                }
            },
            validator: validateCostOfAllCopies,
            render: renderShipmentCalculated((calculated, shipment) => {
                if (shipment.shipmentType === 'colorProof') return null
                return formatIntegerBySpace(Math.round(calculated?.costOfAllCopies || 0))
            }),
        },
        {
            key: 'profitOfAllCopies',
            dataIndex: ['calculated', 'profitOfAllCopies'],
            title: 'Прибыль с тиража',
            width: 80,
            onHeaderCell: () => ({
                style: {
                    backgroundColor: green[1],
                },
            }),
            onCell: (record: any) => {
                return {
                    ...onAnyStandardCell(record),
                    style: {
                        backgroundColor: green[1],
                        fontWeight: '600',
                    },
                }
            },
            validator: validateProfitOfAllCopies,
            render: renderShipmentCalculated((calculated, shipment) => {
                const value = formatIntegerBySpace(Math.round(calculated?.profitOfAllCopies || 0))

                if (shipment.shipmentType !== 'label' || !isShipmentCalculatedOnActual(shipment)) {
                    return value
                }
                const planned = shipment.calculated?.profitOfAllCopies ?? 0
                const actual = shipment.calculatedOnActual?.profitOfAllCopies ?? 0
                const difference = actual - planned

                if (difference === 0) return value
                return (
                    <>
                        {value}{' '}
                        {difference < 0 ? <CaretDownFilled style={{ color: red[5] }} /> : <CaretUpFilled style={{ color: green[5] }} />}
                    </>
                )
            }),
        },
        {
            key: 'turnover',
            dataIndex: ['calculated', 'turnover'],
            title: 'Итого за тираж',
            width: 80,
            onHeaderCell: () => ({
                style: {
                    backgroundColor: magenta[1],
                },
            }),
            onCell: (record: any) => {
                return {
                    ...onAnyStandardCell(record),
                    style: {
                        backgroundColor: magenta[1],
                        fontWeight: '600',
                    },
                }
            },
            render: renderShipmentCalculated(calculated =>
                formatIntegerBySpace(Math.round(calculated?.turnover || 0))
            ),
        },
        {
            key: 'profitPerHour',
            dataIndex: ['calculated', 'profitPerHour'],
            title: 'Прибыль в 1 час',
            width: 80,
            validator: validateProfitPerHour,
            render: renderShipmentCalculated((calculated, shipment) => {
                if (shipment.shipmentType === 'colorProof') return null
                return formatIntegerBySpace(Math.round(calculated?.profitPerHour || 0))
            }),
        },
    ],
}
